// extracted by mini-css-extract-plugin
module.exports = {"grid":"posts-grid_grid__5CKPI"};